export enum SponsorType {
  Manufacturer = 'Manufacturer',
  Retailer = 'Retailer',
}
